import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  addVisitor,
  addVisitProperty,
  editVisitor,
  visitorFormUpdate,
} from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import { handleDetailResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  SourcingHead,
  GRE,
  nextDaycallId,
} from "../../utils/constants";
import { addFollowUp } from "reduxStore/action/followUpActions";
import { getPropertyDetail } from "reduxStore/action/propertyActions";
import AllocateSM from "component/common/AllocateCM";

const EditVisitorNext1 = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const dispatch = useDispatch();
  const visitorDataSelector = useSelector((state) => state.visitorForm);
  const visitSelector = useSelector((state) => state.visitor) || [];
  const [createAndSchedule, setCreateAndSchedule] = useState(false);
  const [configurationsType, setConfigurationsType] = useState([]);
  const [viewDetails, setViewDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [createdLeadId, setCreatedLeadId] = useState(null);
  const [createdPropertyId, setCreatedPropertyId] = useState(null);
  const processedResponseRef = useRef(null); // Track processed responses to prevent infinite loops
  const pendingFollowUpRef = useRef(null); // JUSTO-107: follow-up payload to create after visitor is created (CM/SCM)

  const { response: res } = useSelector((state) => state.login);
  const configurationsSelector = useSelector((state) => state.configurations);
  const visitorDetailSelector = useSelector((state) => state.visitor);
  const getPropertyDetailSelector = useSelector((state) => state.propertyData);

  const role_id = res?.data?.role_id;
  // Debug: Log role info on component mount/update
  useEffect(() => {
    const currentRoleId = String(role_id || "").trim();
    const greRoleId = String(GRE || "").trim();
    console.log("EditVisitorNext1 - Role Check:", {
      role_id: currentRoleId,
      GRE: greRoleId,
      matches: currentRoleId === greRoleId,
      rawRoleId: role_id,
      rawGRE: GRE,
    });
  }, [role_id]);
  const CMTeam =
    ClosingTL === role_id ||
    ClosingManager === role_id ||
    closing_head_id === role_id;

  const SMteam =
    SourcingTL === role_id ||
    SourcingManager === role_id ||
    sourcing_head_id === role_id;

  const mixTeam =
    SCM === role_id ||
    SiteHead === role_id ||
    ClusterHead === role_id ||
    BusinessHead === role_id ||
    admin_id === role_id;

  // CM/SCM only: show walk-in remark and follow-up date/time (same as app AddNewVisitorForm)
  const showWalkinRemarkSection = role_id === ClosingManager || role_id === SCM;

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    if (form.property_id) {
      dispatch(getPropertyDetail({ property_id: form.property_id }));
    }
  }, [dispatch, form.property_id]);

  useEffect(() => {
    const { response } = visitorDataSelector;
    if (visitorDataSelector?.update && response && response !== form) {
      // JUSTO-64: GRE – remove for_sm_id from form when initializing (GRE allocates to CM/SCM only).
      const currentRoleId = String(role_id || "").trim();
      const greRoleId = String(GRE || "").trim();
      const formData = { ...response };

      if (currentRoleId === greRoleId && !formData.lead_id) {
        // Only remove for new visitor creation, not when editing
        formData.for_sm_id = "";
        console.log("GRE Form Initialization - Removed for_sm_id:", {
          original_for_sm_id: response.for_sm_id,
          after_removal: formData.for_sm_id,
        });
      }

      setForm(formData);
    }
  }, [visitorDataSelector, role_id]);

  useEffect(() => {
    if (getPropertyDetailSelector.detail) {
      const { response } = getPropertyDetailSelector;
      if (response?.status === 200) {
        setViewDetails(handleDetailResponse(response?.data));
      } else {
        setViewDetails({});
      }
    }
  }, [getPropertyDetailSelector]);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        if (viewDetails && viewDetails.configuration_area) {
          const configurationIds = viewDetails.configuration_area.map(
            (item) => item.configuration_id,
          );

          // Filter configurations that match the extracted configuration_ids
          const filteredConfigurations = response.data.filter((config) =>
            configurationIds.includes(config._id),
          );

          // Set the filtered configurations
          setConfigurationsType(filteredConfigurations);
        } else {
          // Handle case where configuration_area is undefined or null

          setConfigurationsType([]);
        }
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector, viewDetails]);

  useEffect(() => {
    const { create, response } = visitSelector;
    // Only process if we have a successful creation response and haven't processed it yet
    const responseId = response?.data?._id;
    const responseStatus = response?.status;

    if (create && response && responseStatus === 200 && responseId) {
      // Check if we've already processed this exact response
      if (processedResponseRef.current === responseId) {
        return; // Already processed, skip
      }

      // Mark this response as processed
      processedResponseRef.current = responseId;

      // Check if this is a new visitor creation (not an edit)
      const isNewVisitor = !form?.lead_id;

      // JUSTO-64: GRE – store lead/property for allocation modal; don't redirect until allocated.
      const currentRoleId = String(role_id || "").trim();
      const greRoleId = String(GRE || "").trim();
      const isGREUser = currentRoleId === greRoleId;

      // Debug logs (remove in production)
      console.log("GRE Allocation Check:", {
        role_id: currentRoleId,
        GRE: greRoleId,
        matches: isGREUser,
        isCreating: isNewVisitor,
        responseStatus: responseStatus,
        leadId: response?.data?._id,
        propertyId: response?.data?.property_id,
        formLeadId: form?.lead_id,
      });

      // Handle GRE allocation modal for new visitors
      if (isGREUser && isNewVisitor) {
        const leadId = response?.data?._id;
        const propertyId = response?.data?.property_id;

        if (leadId && propertyId) {
          console.log("Opening Allocate Modal for GRE:", {
            leadId,
            propertyId,
          });
          setCreatedLeadId(leadId);
          setCreatedPropertyId(propertyId);
          setShowAllocateModal(true);
          dispatch(visitorFormUpdate(null));
          return; // Don't navigate, show allocate modal instead
        } else {
          console.log("GRE Modal not opened - missing data:", {
            leadId,
            propertyId,
          });
        }
      }

      // JUSTO-107: CM/SCM – auto-create follow-up with date/time so visitor appears in Today's Follow-up
      const pending = pendingFollowUpRef.current;
      const isCMorSCM = role_id === ClosingManager || role_id === SCM;
      if (
        isCMorSCM &&
        pending &&
        pending.followup_date &&
        pending.followup_time
      ) {
        const leadId =
          response?.data?._id ||
          response?.data?.lead_id ||
          response?.data?.visitor_id ||
          response?._id;
        const appointmentDetail = response?.appointmentDetail;
        const appointmentId =
          appointmentDetail?._id || appointmentDetail?.appointment_id;
        const followUpPayload = {
          lead_id: leadId,
          followup_status: nextDaycallId,
          next_followup_date: pending.followup_date,
          followup_time: pending.followup_time,
          remark: "",
          walkin_remark: pending.walkin_remark || "",
        };
        if (appointmentId) {
          followUpPayload.appointment_id = appointmentId;
          followUpPayload.update_type = 10;
        }
        dispatch(addFollowUp(followUpPayload));
        pendingFollowUpRef.current = null;
      }

      // Normal flow for non-GRE or existing visitors
      dispatch(visitorFormUpdate(null));

      if (createAndSchedule) {
        // Get lead_id and property_id from the response data
        const leadId = response?.data?._id;
        const propertyId = response?.data?.property_id;
        // Construct the URL with query parameters
        const url = `/add_appointment?lead_id=${leadId}&property_id=${propertyId}`;
        // Navigate to the /add_appointment page with query params
        navigatpage(url);
      } else {
        const appointment_id = localStorage.getItem("appointment_id");
        if (response?.appointmentDetail?.appointment_id) {
          if (CMTeam) {
            navigatpage(
              `/viewappointment/${response?.appointmentDetail?.appointment_id}`,
            );
          } else {
            navigatpage("/visitor");
          }
        } else {
          if (appointment_id) {
            navigatpage(`/viewappointment/${appointment_id}`);
            setTimeout(() => {
              localStorage.removeItem("appointment_id");
            }, 5000);
          } else {
            navigatpage("/visitor");
          }
        }
      }
    }
  }, [
    visitSelector.create,
    visitSelector.response?.status,
    visitSelector.response?.data?._id,
  ]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const handleUpdate = async () => {
    if (!handleValid()) {
      setIsLoading(true);
      try {
        if (form?.lead_id !== undefined) {
          await dispatch(editVisitor(form));
        } else {
          // JUSTO-64: GRE – set for_sm_id to empty so new visitor is not assigned to SM (allocate to CM/SCM only).
          const formData = { ...form };
          const currentRoleId = String(role_id || "").trim();
          const greRoleId = String(GRE || "").trim();
          const scmRoleId = String(SCM || "").trim();
          if (currentRoleId === greRoleId || currentRoleId === scmRoleId) {
            formData.for_sm_id = "";
            console.log("GRE/SCM Visitor Creation - Removed for_sm_id:", {
              original_for_sm_id: form.for_sm_id,
              after_removal: formData.for_sm_id,
              formData: formData,
            });
          }

          // JUSTO-107: Store follow-up payload so we can create follow-up after visitor is created (CM/SCM)
          if (
            showWalkinRemarkSection &&
            (form.walkin_remark || "").trim() &&
            (form.followup_date || "").trim() &&
            (form.followup_time || "").trim()
          ) {
            pendingFollowUpRef.current = {
              walkin_remark: (form.walkin_remark || "").trim(),
              followup_date: (form.followup_date || "").trim(),
              followup_time: (form.followup_time || "").trim(),
            };
          } else {
            pendingFollowUpRef.current = null;
          }

          if (formData.property_title) {
            await dispatch(addVisitor(formData));
          } else {
            await dispatch(addVisitProperty(formData));
          }
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCreateAndShedule = async () => {
    if (!handleValid()) {
      setIsLoading(true);
      try {
        setCreateAndSchedule(true);

        // JUSTO-64: GRE – set for_sm_id to empty on schedule flow (allocate to CM/SCM only).
        const formData = { ...form };
        const currentRoleId = String(role_id || "").trim();
        const greRoleId = String(GRE || "").trim();
        if (currentRoleId === greRoleId) {
          formData.for_sm_id = "";
          console.log("GRE Visitor Creation (Schedule) - Removed for_sm_id:", {
            original_for_sm_id: form.for_sm_id,
            after_removal: formData.for_sm_id,
            formData: formData,
          });
        }

        // JUSTO-107: Store follow-up payload for create-and-schedule flow (CM/SCM)
        if (
          showWalkinRemarkSection &&
          (form.walkin_remark || "").trim() &&
          (form.followup_date || "").trim() &&
          (form.followup_time || "").trim()
        ) {
          pendingFollowUpRef.current = {
            walkin_remark: (form.walkin_remark || "").trim(),
            followup_date: (form.followup_date || "").trim(),
            followup_time: (form.followup_time || "").trim(),
          };
        } else {
          pendingFollowUpRef.current = null;
        }

        if (formData.property_title) {
          await dispatch(addVisitor(formData));
        } else {
          await dispatch(addVisitProperty(formData));
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    // JUSTO-100/107: CM role – mandatory walk-in remark, follow-up date and time when creating a new visitor
    const isCM = role_id === ClosingManager;
    const isCreate = !form?.lead_id;
    if (isCM && isCreate) {
      if (!(form?.walkin_remark || "").trim()) {
        err.walkin_remark = strings.remarkErr;
        formError = true;
      }
      if (!(form?.followup_date || "").trim()) {
        err.followup_date = strings.followup_dateErr;
        formError = true;
      }
      if (!(form?.followup_time || "").trim()) {
        err.followup_time = strings.followup_timeErr;
        formError = true;
      }
    }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Visitor Form",
      metaDescription: "Visitor_form",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={form?.lead_id ? strings.editvisitor : strings.addNewVisitor}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={
          form?.lead_id ? strings.editVisitor : strings.addNewVisitor
        }
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>
                  {form?.lead_id ? strings.editvisitor : strings.addNewVisitor}
                </h5>
              </div>

              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.configuration}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="configuration_id"
                          value={form.configuration_id}
                          onChange={(e) => {
                            var index = e.target.selectedIndex;
                            var configuration = e.target[index].text;
                            const nextFormState = {
                              ...form,
                              configuration_id: e.target.value,
                              configuration: configuration,
                            };
                            setForm(nextFormState);
                          }}
                        >
                          <option value={""}>
                            {strings.selectConfiguration}
                          </option>
                          {configurationsType.length > 0 ? (
                            configurationsType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.expectedPossessionPeriode}
                        </label>
                        <select
                          id="expected_possession_periodSelect"
                          name="expected_possession_period"
                          className="form-control"
                          value={form.expected_possession_period}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectExpectedPossession}
                          </option>
                          <option value="3 – 6 Months">
                            {strings.three_to_six_month}
                          </option>
                          <option value="6 Months – 1 Year">
                            {strings.six_to_one_year}
                          </option>
                          <option value="1 – 2 Years">
                            {strings.one_year_to_two_year}
                          </option>
                          <option value="2 Years and Above">
                            {strings.two_year_and_above}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.budgetAmount}
                        </label>
                        <select
                          id="budget_amountSelect"
                          name="budget_amount"
                          className="form-control"
                          value={form.budget_amount}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectBudgetAmount}</option>
                          <option value="Below - 50L">
                            {strings.below_50_lakhs}
                          </option>
                          <option value="50L - 75L">
                            {strings.fifty_lakhs_to_seventy_five_lakhs}
                          </option>
                          <option value="75L - 1Cr">
                            {strings.seventy_five_lakhs_to_one_crore}
                          </option>
                          <option value="1Cr - 1.30Cr">
                            {strings.one_crore_to_1_30_crore}
                          </option>
                          <option value="1.31Cr - 1.50Cr">
                            {strings.one_31_crore_to_1_50_crore}
                          </option>
                          <option value="1.51Cr - 1.75Cr">
                            {strings.one_51_crore_to_1_75_crore}
                          </option>
                          <option value="1.76Cr - 2Cr">
                            {strings.one_76_crore_to_2_crore}
                          </option>
                          <option value="2Cr - 2.5Cr">
                            {strings.two_crore_to_2_5_crore}
                          </option>
                          <option value="2.5Cr and above">
                            {strings.above_2_5_crore}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.Area}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          name="areain_sqlft"
                          value={form.areain_sqlft}
                          onChange={handleInputField}
                          placeholder={strings.Area}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.natureOffunding}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline1"
                                type="radio"
                                name="funding_type"
                                value={"loan"}
                                checked={
                                  form.funding_type === "loan" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline1">
                                {strings.loan}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline2"
                                type="radio"
                                name="funding_type"
                                value={"self"}
                                checked={
                                  form.funding_type === "self" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline2">
                                {strings.selfFunding}
                              </label>
                            </div>
                            <div className="radio radio-primary ml-5">
                              <input
                                id="radioinline3"
                                type="radio"
                                name="funding_type"
                                value={"both"}
                                checked={
                                  form.funding_type === "both" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline3">
                                {strings.both}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.Purpose}
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline4"
                                type="radio"
                                name="purpose"
                                value={"end user"}
                                checked={
                                  form.purpose === "end user" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline4">
                                {strings.endUser}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline5"
                                type="radio"
                                name="purpose"
                                value={"invest"}
                                checked={
                                  form.purpose === "invest" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline5">
                                {strings.invesment}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CM/SCM only: Walk-in remark and follow-up date/time */}
                {showWalkinRemarkSection && (
                  <div className="rounded px-4 py-0 mb-1">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label
                            htmlFor="walkin_remark"
                            className="form-label fw-semibold"
                            style={{ color: "#495057" }}
                          >
                            {strings.walkinRemark}
                          </label>
                          <input
                            className={`form-control ${formVaild.walkin_remark ? "is-invalid" : ""}`}
                            type="text"
                            id="walkin_remark"
                            name="walkin_remark"
                            value={form.walkin_remark || ""}
                            placeholder={strings.walkinRemark}
                            onChange={handleInputField}
                            autoComplete="off"
                            style={{ maxWidth: "100%" }}
                          />
                          {formVaild.walkin_remark && (
                            <div className="invalid-feedback d-block">
                              {formVaild.walkin_remark}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            htmlFor="followup_date"
                            className="form-label fw-semibold"
                            style={{ color: "#495057" }}
                          >
                            {strings.addVisitorFollowupDate}
                          </label>
                          <input
                            className={`form-control ${formVaild.followup_date ? "is-invalid" : ""}`}
                            type="date"
                            id="followup_date"
                            name="followup_date"
                            value={form.followup_date || ""}
                            min={new Date().toISOString().split("T")[0]}
                            onChange={handleInputField}
                          />
                          {formVaild.followup_date && (
                            <div className="invalid-feedback d-block">
                              {formVaild.followup_date}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            htmlFor="followup_time"
                            className="form-label fw-semibold"
                            style={{ color: "#495057" }}
                          >
                            {strings.addVisitorFollowupTime}
                          </label>
                          <input
                            className={`form-control ${formVaild.followup_time ? "is-invalid" : ""}`}
                            type="time"
                            id="followup_time"
                            name="followup_time"
                            value={form.followup_time || ""}
                            onChange={handleInputField}
                          />
                          {formVaild.followup_time && (
                            <div className="invalid-feedback d-block">
                              {formVaild.followup_time}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  {form.lead_id && (
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={() => handleUpdate()}
                        >
                          {form?.lead_id
                            ? strings.update
                            : strings.createVisitor}
                        </button>
                      </div>
                    </div>
                  )}
                  {!form.lead_id && (
                    <>
                      <div
                        className={`col-md-${
                          CMTeam ? "12" : "6"
                        } d-flex justify-content-center`}
                      >
                        <div className="card-footer">
                          <button
                            className="btn btn-color"
                            type="button"
                            onClick={() => handleUpdate()}
                            disabled={isLoading}
                          >
                            {isLoading
                              ? "Processing..."
                              : form?.lead_id
                                ? strings.update
                                : strings.createVisitor}
                          </button>
                        </div>
                      </div>
                      {!CMTeam && (
                        <div className="col-md-6 d-flex justify-content-center">
                          <div className="card-footer">
                            <button
                              className="btn btn-color"
                              type="button"
                              onClick={() => handleCreateAndShedule()}
                              disabled={isLoading}
                            >
                              {isLoading
                                ? "Processing..."
                                : form?.lead_id
                                  ? strings.update
                                  : strings.createAndSchedule}
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* JUSTO-64: GRE – Allocate to Closing Manager / SCM modal */}
      {(() => {
        const isGREUser =
          String(role_id || "").trim() === String(GRE || "").trim();
        console.log("Modal Render Check:", {
          isGREUser,
          showAllocateModal,
          createdLeadId,
          createdPropertyId,
          role_id,
          GRE,
        });
        return (
          isGREUser && showAllocateModal && createdLeadId && createdPropertyId
        );
      })() && (
        <AllocateSM
          show={showAllocateModal}
          propertyId={createdPropertyId}
          leadId={createdLeadId}
          handleClose={() => {
            setShowAllocateModal(false);
            setCreatedLeadId(null);
            setCreatedPropertyId(null);
            // Small delay to ensure state updates before navigation
            setTimeout(() => {
              navigatpage("/visitor");
            }, 100);
          }}
          onAllocateSuccess={() => {
            setShowAllocateModal(false);
            setCreatedLeadId(null);
            setCreatedPropertyId(null);
            // Small delay to ensure state updates before navigation
            setTimeout(() => {
              navigatpage("/visitor");
            }, 100);
          }}
        />
      )}
    </div>
  );
};
export default EditVisitorNext1;
